module.exports = __webpack_public_path__ + "static/scale-model-of-kern-county-veterans-memorial-in-bakersfield-california-0dfeb4038096fdc4b33f77f1c1eb5d18.png";